module.exports = __webpack_public_path__ + "img/MTV.0da1f3e0.jpg";